














































import { computed, defineComponent, ref } from "@vue/composition-api";
import { format } from "date-fns";
import { MassMessage } from "@scrile/api-provider/dist/api/MassMessageProvider";
import { isAudioFile, isImageFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { getMainCurrencyCode } from "@/lib/moneyHelpers";
import BaseIcon from "@/components/BaseIcon";
import BaseImage from "@/components/BaseImage";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "ScheduledMassMessageStatItem",
  components: { BaseIcon, BaseImage, FormatMoney },
  props: {
    massMessage: { type: Object as () => MassMessage, required: true },
    recipientsCount: { type: Number, default: 0 },
    cost: { type: Number, default: 0 },
  },
  setup(props) {
    const textContainer = ref<HTMLElement | null>(null);
    const showFullText = ref(false);

    const mainCurrency = computed(() => getMainCurrencyCode());
    const date = computed(() => {
      return format(new Date(props.massMessage.publishTime), "MM/dd/yy");
    });
    const time = computed(() => {
      return format(new Date(props.massMessage.publishTime), "hh:mm a");
    });
    const previewSrc = computed(() => {
      if (props.massMessage.files.length === 0) return null;

      const file = props.massMessage.files[0];
      if (!isAudioFile(file)) {
        return isImageFile(file)
          ? MediaFilesController.getImageThumbnail(file.urlPart, 72)
          : MediaFilesController.getVideoThumbnail(file.urlPart, 72);
      }
    });
    const action = computed(() => {
      if (textContainer.value) {
        return (
          textContainer.value.scrollWidth > textContainer.value.offsetWidth ||
          textContainer.value.scrollHeight > textContainer.value.offsetHeight
        );
      } else return false;
    });

    const filesCount = computed<number>(() => props.massMessage.files.length);

    return {
      mainCurrency,
      date,
      time,
      action,
      previewSrc,
      filesCount,
      showFullText,
      textContainer,
    };
  },
});
